module.exports = __webpack_public_path__ + "img/tm.c6be4f16.png";